import { motion } from "framer-motion";
import { CheckCircle2, Truck, Award, BadgePercent, Map, Layers, Network } from "lucide-react";

const ADVANTAGES = [
  {
    icon: Layers,
    title: "Широкая номенклатура",
    desc: "От базовых промышленных товаров до промышленной мебели и электромеханики — снабжение по нескольким направлениям в одной точке.",
    span: "md:col-span-2",
  },
  {
    icon: CheckCircle2,
    title: "Проверенные поставщики",
    desc: "Работаем напрямую с производителями и официальными дистрибьюторами.",
    span: "md:col-span-1",
  },
  {
    icon: Truck,
    title: "Быстрая доставка",
    desc: "Отгрузка через транспортные компании и партнёров.",
    span: "md:col-span-1",
  },
  {
    icon: Award,
    title: "Качество продукции",
    desc: "Товары с сопроводительной документацией и гарантией производителя.",
    span: "md:col-span-1",
  },
  {
    icon: Network,
    title: "Подбор технических решений",
    desc: "Помогаем подбирать решения под задачу заказчика: от аналогов до комплектных решений для электротранспорта, складской техники и промышленной автоматизации.",
    span: "md:col-span-2",
  },
  {
    icon: BadgePercent,
    title: "Выгодные цены",
    desc: "Прозрачное ценообразование и объёмные скидки для постоянных клиентов.",
    span: "md:col-span-1",
  },
  {
    icon: Map,
    title: "Работа по всей России",
    desc: "Поставки во все федеральные округа. Гибкие условия по географии и логистике. Партнёрская сеть по регионам и промышленным направлениям.",
    span: "md:col-span-3",
  },
];

export default function Advantages() {
  return (
    <section
      id="advantages"
      data-testid="advantages-section"
      className="section bg-white relative bg-grain"
    >
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-14 lg:mb-20 items-end">
          <div className="lg:col-span-6">
            <div className="eyebrow mb-6">Преимущества</div>
            <h2 className="font-display text-[#0A192F] text-3xl sm:text-4xl lg:text-5xl font-semibold leading-[1.1] tracking-tight">
              Почему предприятия выбирают Бизора Логистик
            </h2>
          </div>
          <p className="lg:col-span-5 lg:col-start-8 text-slate-600 text-base lg:text-lg">
            Работаем так, чтобы вы получали именно то, что нужно, в нужный срок и без лишней бюрократии.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-6">
          {ADVANTAGES.map((a, i) => {
            const Icon = a.icon;
            return (
              <motion.div
                key={a.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                data-testid={`advantage-${i}`}
                className={`relative group ${a.span} bg-[#F8FAFC] hover:bg-white border border-slate-200 hover:border-[#0A192F] p-8 lg:p-10 transition-all overflow-hidden`}
              >
                <div className="absolute top-0 right-0 w-24 h-24 bg-[#FF6B00]/0 group-hover:bg-[#FF6B00]/5 transition-colors" />
                <div className="relative flex items-start gap-6">
                  <div className="w-14 h-14 shrink-0 bg-[#0A192F] flex items-center justify-center group-hover:bg-[#FF6B00] transition-colors">
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <div className="text-xs uppercase tracking-[0.2em] text-slate-400 mb-2 tabular-nums">
                      0{i + 1}
                    </div>
                    <h3 className="font-display text-[#0A192F] text-xl lg:text-2xl font-semibold leading-snug">
                      {a.title}
                    </h3>
                    <p className="mt-3 text-slate-600 text-base leading-relaxed">
                      {a.desc}
                    </p>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
